import { useReducer as useReducerReactHook } from 'react'
import _ from 'lodash'

const updateState = (state, action) => {
  let updatedState = { ...state }
  _.set(updatedState, action.key, action.value)
  return updatedState
}
const defaultReducer = (state, action) => {
  return action.resetTo ? action.resetTo : updateState(state, action)
}
export default function useLocalForm (initialState) {
  const frozenInitialState = { ...initialState }
  const [state, dispatch] = useReducerReactHook(defaultReducer, { ...initialState })
  return { state, dispatch, reset: () => dispatch({ resetTo: frozenInitialState }) }
}